module.exports = __webpack_public_path__ + "static/media/A1-19-Nubb-cod117.a6299b26.png";